import { Button, Modal, Form, Row, Col, message, DatePicker } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleRescheduleTraining } from "../../../api/training";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";

export default function RescheduleTraining({
  isVisible,
  setVisible,
  training_id,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleRescheduleTraining,
    onSuccess: () => {
      message.success("Assigned Successfully");
      form.resetFields();
      queryClient.invalidateQueries({
        queryKey: ["allTrainings", training_id],
      });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    await mutate({ training_id, data: { ...values } });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title="Reschedule Training"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="RescheduleTraining"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="RescheduleTraining"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="start"
              label="Start date"
              rules={[
                {
                  required: true,
                  message: "Please enter start date",
                },
              ]}
            >
              <DatePicker
                format={"DD/MM/YYYY"}
                className="w-full"
                disabledDate={(current) => {
                  let customDate = moment().format("YYYY-MM-DD");
                  return current && current < moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="end"
              label="End date"
              rules={[
                {
                  required: true,
                  message: "Please enter end date",
                },
              ]}
            >
              <DatePicker
                format={"DD/MM/YYYY"}
                className="w-full"
                disabledDate={(current) => {
                  let customDate = moment().format("YYYY-MM-DD");
                  return current && current < moment(customDate, "YYYY-MM-DD");
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="remarks"
              label="Remarks ( Optional )"
              rules={[
                {
                  required: false,
                  message: "Please enter remarks",
                },
              ]}
            >
              <TextArea placeholder="Remarks" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
